import React from 'react';

/**
 * Seitenrahmen der Teilnehmerseite: grauer Grund, weisse Karte (max-w-2xl),
 * Fortschrittsleiste oben. Layout wie SignaturePadPage — dvh statt vh und
 * Safe-Area-Polster, damit auf dem iPhone nichts hinter der Leiste haengt.
 */
export const TeilnahmeRahmen: React.FC<{
  /** 0..100; undefined blendet die Leiste aus (Laden, Fehler). */
  prozent?: number;
  /** Kleiner Text rechts ueber der Leiste, z. B. „Abschnitt 2 von 5". */
  schrittText?: string;
  /**
   * Steht ueber der Karte und bleibt auf jedem Schritt stehen — Testlauf-Banner
   * oder Ruecklink „Alle Unterweisungen" vom Sammel-Link.
   */
  oben?: React.ReactNode;
  children: React.ReactNode;
}> = ({ prozent, schrittText, oben, children }) => (
  <div
    className="min-h-screen bg-slate-100 flex flex-col items-center p-4 gap-4"
    style={{
      minHeight: '100dvh',
      paddingTop: 'calc(1rem + env(safe-area-inset-top))',
      paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))',
    }}
  >
    {oben && <div className="w-full max-w-2xl space-y-2">{oben}</div>}
    <main className="bg-white rounded-2xl shadow-sm border border-slate-200 p-5 w-full max-w-2xl space-y-5 text-base text-slate-800">
      {prozent !== undefined && (
        <div className="space-y-1.5">
          <div className="flex items-center justify-between text-sm text-slate-500">
            <span>Fortschritt</span>
            {schrittText && <span>{schrittText}</span>}
          </div>
          <div
            role="progressbar"
            aria-label="Fortschritt der Unterweisung"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(prozent)}
            className="h-2.5 w-full bg-slate-200 rounded-full overflow-hidden"
          >
            <div className="h-full bg-blue-600 rounded-full transition-all" style={{ width: `${Math.max(0, Math.min(100, prozent))}%` }} />
          </div>
        </div>
      )}
      {children}
    </main>
  </div>
);
